module.exports = __webpack_public_path__ + "img/WeChat.57eee041.jpg";